const status = {
  IN_PROGRESS: 'inProgress',
  SUCCESS: 'success',
  FAILED: 'failed',
};

module.exports = {
  status,
};
